import { Box, Text } from "@chakra-ui/react";
import { useEnv } from "../hooks/useEnv";

export default function ProdEnvBanner() {
  const env = useEnv();
  if (env !== "dev") return null;
  return (
    <Box
      bg="green.600"
      color="white"
      px={6}
      py={1.5}
      textAlign="center"
      borderBottomWidth="1px"
      borderBottomColor="green.700"
    >
      <Text fontSize="sm" fontWeight="bold" letterSpacing="wide">
        DEV — all data is fake - party on Wayne
      </Text>
    </Box>
  );
}
